<div
  ng2FileDrop
  [uploader]="uploader"
  class="d-flex align-items-center gap-3 bg-default3 p-3 upload-box position-relative"
>
  <img [src]="image ? image : '/assets/images/upload-files.svg'" alt="" [style.height]="imageHeight" />
  <div>
    <h5 class="text-lg text-dark">
      <ng-container i18n>Drop files here or</ng-container>&nbsp;
      <a href="javascript:;" (click)="fileInput.click()" i18n>Browse</a>&nbsp;
      <ng-container i18n>to upload</ng-container>
      <input
        type="file"
        [accept]="acceptFileExtensions"
        #fileInput
        ng2FileSelect
        [uploader]="uploader"
        multiple
        class="d-none"
        capture="environment"
      />
    </h5>
    <div [innerHTML]="getGuideText()" class="text-sm text-light"></div>
  </div>
  <div
    *ngIf="uploader?.isUploading && showUploadingBar"
    class="position-absolute d-flex align-items-center justify-content-center rounded bg-secondary"
    style="opacity: 0.9; top: 0; bottom: 0; left: 0; right: 0"
  >
    <ngb-progressbar type="success" [value]="uploader?.progress" [striped]="true" [animated]="true" style="width: 90%"
      ><i i18n>Uploading</i></ngb-progressbar
    >
  </div>

  <ng-content></ng-content>
</div>

<div class="table-responsive" *ngIf="files.length && showFileList">
  <table class="table table-condensed" aria-hidden="false">
    <thead>
      <tr>
        <th class="text-sm text-semi-bold border-top-0" i18n>Name</th>
        <th class="text-sm text-semi-bold border-top-0" i18n>Size</th>
        <th class="text-sm text-semi-bold border-top-0" i18n>Progress</th>
        <th class="text-sm text-semi-bold border-top-0" i18n>Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let file of files; let i = index">
        <td>{{ file.file.name }}</td>
        <td>{{ file.file.size | fileSize }}</td>
        <td class="align-middle">
          <mat-progress-bar mode="determinate" [value]="file.progress"></mat-progress-bar>
        </td>
        <td>
          <a
            (click)="!file.isUploading && onRemoveFile(file, i)"
            class="td-btn text-danger"
            [ngClass]="{ disabled: file.isUploading }"
          >
            <i class="cs-icon cs-icon-trash"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
